module.exports = __webpack_public_path__ + "static/36-533ad2326d084450a232a497102591d0.jpg";